import { Component, OnInit, Input } from '@angular/core';
import { CoreService } from 'src/app/service/core.service';

@Component({
  selector: 'app-client-ccd-print',
  templateUrl: './client-ccd-print.component.html',
  styleUrls: ['./client-ccd-print.component.css']
})
export class ClientCcdPrintComponent implements OnInit {
  @Input()saleQtnData;
  @Input()print_style;
  @Input()qr_inv;
  @Input()savedTemplate;
  @Input()is_prew_description;
  @Input()payTypes;
  @Input()base_url;
  @Input()previewLoader;
  @Input()logoImgUrl;
  @Input()tempImgUrl;
  @Input()sales_print_name;
  @Input()hide_item_discount;
  @Input()hide_vat;
  country_dec: any;
  constructor(private coreService: CoreService,) { }

  ngOnInit() {

    this.country_dec=this.coreService.setDecimalLength();
  }

}
